/**
 * Format date to dd/MM/yyyy format
 * @param dateString - ISO date string or Date object
 * @returns Formatted date string in dd/MM/yyyy format
 */
export const formatDateToDDMMYYYY = (dateString: string | Date): string => {
  if (!dateString) return '';

  const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

  if (isNaN(date.getTime())) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();

  return `${day}/${month}/${year}`;
};

export const getYearFromDate = (dateString: string | Date): number | null => {
  if (!dateString) return null;

  const date = typeof dateString === 'string' ? new Date(dateString) : dateString;

  if (isNaN(date.getTime())) return null;

  return date.getFullYear();
};

/**
 * Convert dd/MM/yyyy format to yyyy-MM-dd (for HTML date input)
 * @param dateString - Date string in dd/MM/yyyy format
 * @returns ISO date string in yyyy-MM-dd format
 */
export const formatDDMMYYYYToISO = (dateString: string): string => {
  if (!dateString) return '';

  const [day, month, year] = dateString.split('/');

  if (!day || !month || !year) return '';

  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

/**
 * Display date in Vietnamese locale with dd/MM/yyyy format
 * @param dateString - ISO date string
 * @returns Formatted date string
 */
export const formatDateForDisplay = (dateString: string): string => {
  return formatDateToDDMMYYYY(dateString);
};

export const formatBirthParts = (day?: number | null, month?: number | null, year?: number | null): string => {
  if (!day && !month && !year) return '';
  return [day, month, year].filter((part) => part !== null && part !== undefined && part !== '').join('/');
};

export const calculateAge = (
  birthYear?: number | null,
  diedYear?: number | null,
  isAlive: boolean = true
): number | null => {
  if (!birthYear) return null;

  const endYear = isAlive ? new Date().getFullYear() : diedYear;
  if (!endYear || endYear < birthYear) return null;

  return endYear - birthYear + 1;
};
